import React from "react";
import clsx from "clsx";
import styles from "./index-score.module.scss";
import { svgIcons } from "utility/svgIcons";

const {
  IconArrowDownBlackBig,
  IconArrowUpBlackBig,
  IconArrowDownWhiteMedium,
  IconArrowUpWhiteMedium,
  IconArrowDownBlackSmall,
  IconArrowUpBlackSmall,
} = svgIcons();
interface IndexScoreProps {
  indexScoreData?: any;
  size: "big" | "medium" | "small" | "default";
  className?: string;
  showIcon?: boolean;
}
const IndexScore = ({
  indexScoreData,
  size,
  className,
  showIcon = true,
}: IndexScoreProps) => {
  let indexScoreValue = "0";
  if (indexScoreData?.value) {
    indexScoreValue = indexScoreData?.value;
  }

  let IndexScoreIcon;
  if (showIcon && indexScoreData?.icon) {
    if (size === "big") {
      if (indexScoreData.icon === "index-down") {
        IndexScoreIcon = IconArrowDownBlackBig;
      } else {
        IndexScoreIcon = IconArrowUpBlackBig;
      }
    } else if (size === "medium") {
      if (indexScoreData.icon === "index-down") {
        IndexScoreIcon = IconArrowDownWhiteMedium;
      } else {
        IndexScoreIcon = IconArrowUpWhiteMedium;
      }
    } else if (size === "small") {
      if (indexScoreData.icon === "index-down") {
        IndexScoreIcon = IconArrowDownBlackSmall;
      } else {
        IndexScoreIcon = IconArrowUpBlackSmall;
      }
    }
  }

  return (
    <div className={clsx(styles["index-container"], className)}>
      {indexScoreValue && (
        <>
          <span className={styles[`index-score-${size}`]}>
            {indexScoreValue}
          </span>
          <span className={styles[`index-score-percentage-${size}`]}>%</span>
        </>
      )}
      {IndexScoreIcon && (
        <span className={styles[`index-arrow-${size}`]}>{IndexScoreIcon}</span>
      )}
    </div>
  );
};
export default IndexScore;
